import React from 'react';
import { Navigate } from 'react-router-dom';

const GetToken = () => {
    const token = localStorage.getItem('activeusertoken'); 


	return token ? token : false;
};

export default GetToken;
